import NotFoundTemplate from "../templates/NotFoundTemplate";

export default function NotFoundPage(){
    return <NotFoundTemplate />
}